/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumBurgerMenu: {
    name: 'big-medium-burger-menu';
    data: string;
} = {
    name: 'big-medium-burger-menu',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M8.13 29h111.74a5 5 0 0 0 0-10H8.13a5 5 0 0 0 0 10m111.74 29.37H8.13a5 5 0 0 0 0 10h111.74a5 5 0 0 0 0-10m0 40.63H8.13a5 5 0 1 0 0 10h111.74a5 5 0 0 0 0-10"/></svg>`,
};
